<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub1')}}</p>
        <p class="mt-3">{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__2_org_information')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <label><strong>{{$t('medium_grant.diligence__2_official_org_name')}}</strong></label>
        <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.officialNameOfOrg"
            v-model="GrantForm.model.diligence.officialNameOfOrg"
            :error="getError('diligence.officialNameOfOrg')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.diligence__2_official_org_name')"
            :placeholder="$t('medium_grant.diligence__2_official_org_name')"
          >
          </textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <label><strong>{{$t('medium_grant.diligence__2_type_of_org')}}</strong></label>
        <div>
          <small>{{$t('medium_grant.diligence__2_please_tick_appropiate')}}</small>
        </div>
        <div class="mt-3"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.forProfit">
          {{$t('medium_grant.diligence__2_for_profit')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.notForProfit">
          {{$t('medium_grant.diligence__2_not_for_profit')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.governmentAgency">
          {{$t('medium_grant.diligence__2_government_agency')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.incCompany">
          {{$t('medium_grant.diligence__2_inc_company')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.llcCompany">
          {{$t('medium_grant.diligence__2_llc_company')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.spCompany">
          {{$t('medium_grant.diligence__2_sp_company')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.partnership">
          {{$t('medium_grant.diligence__2_partnership')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.registeredCharity">
          {{$t('medium_grant.diligence__2_registered_charity')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.communityNetwork">
          {{$t('medium_grant.diligence__2_community_network')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.diligence.other">
          {{$t('medium_grant.diligence__2_other')}}
        </base-checkbox>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.diligence.orgInfoOther"
            >
            </textarea>
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__2_founding_documents')}}</strong></label>
        <div>
          <small>{{$t('medium_grant.diligence__2_founding_documents_sub')}}</small>
        </div>
        <div class="mt-3"></div>
        <table class="mt-3" width="100%">
          <thead>
          <th>{{$t('medium_grant.diligence__2_country')}}</th>
          <th>{{$t('medium_grant.diligence__2_title_of_founding_doc')}}</th>
          <th>{{$t('medium_grant.diligence__2_upload')}}</th>
          </thead>
          <tbody>
          <tr v-for="(item, index) in foundingDocuments" :key="index">
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="item.country"
            :placeholder="$t('medium_grant.diligence__2_country')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="item.title"
            :placeholder="$t('medium_grant.diligence__2_title_of_founding_doc')"
          >
          </textarea>
              </div>
            </td>
            <td class="align-baseline">
              <upload-file v-model="GrantForm.files.diligence['foundingDocuments' + (index+1)]" :file-data="GrantForm.files.diligence['foundingDocuments' + (index+1)]" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isEditable" :section="'diligence.foundingDocuments' + (index + 1)"></upload-file>
            </td>
          </tr>
          </tbody>
          <base-button v-if="foundingDocuments.length < maxFoundingDocumentsRows" @click="addFoundingDocumentRow" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>

        <div class="mt-5">
          <small>{{$t('medium_grant.diligence__2_founding_documents_sub2')}}</small>
          <sup><a class="text-link font-weight-bold ml-1" href="#note1">[1]</a></sup>
        </div>
        <div class="mt-3"></div>
        <table class="mt-3" width="100%">
          <thead>
          <th>{{$t('medium_grant.diligence__2_country')}}</th>
          <th>{{$t('medium_grant.diligence__2_title_of_founding_doc')}}</th>
          <th>{{$t('medium_grant.diligence__2_upload')}}</th>
          </thead>
          <tbody>
          <tr v-for="(item, index) in foundingDocuments2" :key="index">
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="item.country"
            :placeholder="$t('medium_grant.diligence__2_country')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="item.title"
            :placeholder="$t('medium_grant.diligence__2_title_of_founding_doc')"
          >
          </textarea>
              </div>
            </td>
            <td class="align-baseline">
              <upload-file v-model="GrantForm.files.diligence['supportingDocumentation' + (index+1)]" :file-data="GrantForm.files.diligence['supportingDocumentation' + (index+1)]" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isEditable" :section="'diligence.supportingDocumentation' + (index + 1)"></upload-file>
            </td>
          </tr>
          </tbody>
          <base-button v-if="foundingDocuments2.length < maxFoundingDocumentsRows" @click="addFoundingDocument2Row" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>
        <p class="mt-4" id="note1">{{$t('medium_grant.diligence__2_founding_documents_sub2_note')}}</p>

        <label class="mt-5"><strong>{{$t('medium_grant.diligence__2_owenership_details')}}</strong></label>
        <div>
          <small><strong>{{$t('medium_grant.diligence__2_owenership_details_below')}}</strong></small>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.diligence.ownershipDetails"
            >
            </textarea>
        </base-input>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        foundingDocuments: [{}, {}],
        foundingDocuments2: [{}, {}],
        maxFoundingDocumentsRows: 5
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addFoundingDocumentRow() {
        if (this.foundingDocuments.length >= this.maxFoundingDocumentsRows) return;
        this.foundingDocuments.push({});
      },
      addFoundingDocument2Row() {
        if (this.foundingDocuments2.length >= this.maxFoundingDocumentsRows) return;
        this.foundingDocuments2.push({});
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    watch: {
      foundingDocuments(value) {
        GrantForm.model.diligence.foundingDocuments = value;
      },

      foundingDocuments2(value) {
        GrantForm.model.diligence.foundingDocuments2 = value;
      }
    },
    mounted() {
      if (GrantForm.model.diligence.foundingDocuments) {
        this.foundingDocuments = GrantForm.model.diligence.foundingDocuments;
      }

      if (GrantForm.model.diligence.foundingDocuments2) {
        this.foundingDocuments2 = GrantForm.model.diligence.foundingDocuments2;
      }
    }
  }
</script>
